export default "__VITE_ASSET__BYJQVCSP__"